<template>
  <div class="overflow-hidden relative bg-white">
    <section class="text-center m-8">
      <p class="text-base">
        <span class="font-semibold text-[24px] lg:text-4xl">{{
          getLocalized(contentData, "title")
        }}</span>
      </p>
    </section>

    <!-- Splide Slider -->
    <div class="splide py-12">
      <div class="splide__track">
        <ul class="splide__list">
          <li
            v-for="(partner, index) in partners"
            :key="index"
            class="splide__slide"
          >
            <img
              :src="partner.image"
              class="w-[40px] h-[40px] md:w-[80px] md:h-[80px]"
            />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import { useLocalization } from "@/composable/useLocalization";
import { fetchContentSection } from "@/composable/apiService";
import axios from "axios";
export default {
  data() {
    return {
      partners: [],
      api: process.env.VUE_APP_API_KEY,
      contentData: {},
      currentLang: localStorage.getItem("language") || "en",
    };
  },
  computed: {
    getLocalized() {
      const { getLocalized } = useLocalization();
      return getLocalized;
    },
  },
  methods: {
    async fetchPartner() {
      try {
        this.contentData = await fetchContentSection(3);

        const response = await axios.get(this.api + "/api/trusted-by");
        this.partners = response.data.items.map((item) => ({
          image: `${this.api}${item.logo_path}`,
        }));

        // Reinitialize Splide after updating partners2
        this.$nextTick(() => {
          new Splide(".splide", {
            type: "loop",
            perPage: 6,
            drag: "free",
            focus: "center",
            gap: "1rem",
            autoScroll: {
              speed: 1,
            },
            pagination: false,
            arrows: false,
            breakpoints: {
              768: {
                perPage: 4,
                gap: "1rem",
              },
              480: {
                perPage: 3,
                gap: "0.5rem",
              },
            },
          }).mount({ AutoScroll });
        });
      } catch (e) {
        console.error(e);
      }
    },
  },
  mounted() {
    this.fetchPartner();
  },
};
</script>

<style scoped>
.splide {
  margin: 0 auto;
  max-width: 100%; /* Ensure it adapts to your layout */
}

.splide__slide img {
  display: block;
  margin: 0 auto;
  object-fit: contain; /* Ensures logos scale properly */
  max-height: 80px; /* Adjust max height for consistency */
}
</style>
